module.exports = __webpack_public_path__ + "img/dummyLogo.f2e03c2c.png";